module.exports = __webpack_public_path__ + "static/media/cogwheel.d7d23e97.svg";